<template>
  <div>
    <!-- 文件夹操作弹框 -->
    <van-popup
      v-model="docFolidOperate"
      position="bottom"
      get-container="body"
      round
      :style="{ height: '31.5%', width: '100%' }"
      @closed="closeDocFolidOperate"
    >
      <div class="doc-folid-box">
        <div class="doc-folid-item" @click="renameDocFolid">重命名文件夹</div>
        <div class="doc-folid-item" @click="removeDocFolid">移动文件夹</div>
        <div class="doc-folid-item" @click="addDocFolid">增加子文件夹</div>
        <div
          class="doc-folid-item"
          style="margin-bottom:6px;"
          @click="cancelDocFolid"
        >
          删除该文件夹
        </div>
        <div class="doc-folid-item" @click="closeDocFolidOperate">取消</div>
      </div>
    </van-popup>
    <van-dialog
      v-model="renameFolidPopShow"
      :title="folidTitle ? '增加子文件夹' : '重命名文件夹'"
      message-align="center"
      confirmButtonColor="#4D340C"
      cancelButtonColor="#333"
      show-cancel-button
      @confirm="renameFolidSure"
      @cancel="renameFolidCancel"
      style="padding:0 10px"
    >
      <van-field
        v-model="renameFolidValue"
        placeholder="请输入文件夹名"
        border
      />
    </van-dialog>
    <van-popup
      v-model="removeDocFolidShow"
      position="bottom"
      get-container="body"
      round
      :style="{
        height: '90%',
        width: '100%',
        padding: '30px 0 0 0',
      }"
    >
      <div class="remove-doc-title">移动文件夹</div>
      <list-tree
        :data="lists"
        v-model="selectVal"
        value-key="dir_id"
        label-key="dir_name"
        disabled-key="disabled"
        toastText="该选项不可选择"
      />
      <div class="remove-doc-btn-box">
        <van-button
          plain
          hairline
          round
          class="cancel-remove-doc"
          @click="cancelRemoveDoc"
          >取消</van-button
        >
        <van-button round class="sure-remove-doc" @click="sureRemoveDoc"
          >移动</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import ListTree from "../listTree/index";

export default {
  props: {
    docFolidInfo: {
      type: Object,
      default: function() {
        return {};
      },
    },
    docFolidOperateShow: {
      type: Boolean,
    },
  },
  components: {
    ListTree,
  },
  data() {
    return {
      renameFolidPopShow: false, // 重命名文件夹弹框
      renameFolidValue: "",
      folidTitle: true, // 增加和重命名标题
      removeDocFolidShow: false, // 移动文件夹弹框
      selectVal: {},
      lists: [],
    };
  },
  methods: {
    // 重命名文件夹
    renameDocFolid() {
      this.folidTitle = false;
      console.log(this.docFolidInfo);
      this.renameFolidValue = this.docFolidInfo.dir_name;
      this.renameFolidPopShow = true;
    },
    // 文件夹更改确定
    renameFolidSure() {
      if (this.folidTitle) {
        // 增加子文件夹
      } else {
        // 重命名文件夹
      }
    },
    // 文件夹更改取消
    renameFolidCancel() {},
    // 移动文件夹
    removeDocFolid() {
      this.removeDocFolidShow = true;
      this.lists = JSON.parse(localStorage.getItem("fixedFolderArr"));
      // this.getTreeList();
    },

    cancelRemoveDoc() {
      this.removeDocFolidShow = false;
    },
    sureRemoveDoc() {},

    // 增加子文件夹
    addDocFolid() {
      this.folidTitle = true;
      this.renameFolidValue = "";
      this.renameFolidPopShow = true;
    },
    // 删除该文件夹
    cancelDocFolid() {
      this.$dialog
        .confirm({
          title: "是否删除该文件夹？",
        })
        .then(() => {
          // on confirm
          this.closeAllPop();
        })
        .catch(() => {
          // on cancel
        });
    },
    // 关闭操作弹框
    closeDocFolidOperate() {
      this.$emit("update:docFolidOperateShow", false);
    },

    // 完成操作关闭弹框
    closeAllPop() {
      this.renameFolidPopShow = false;
      this.removeDocFolidShow = false;
      this.$emit("update:docFolidOperateShow", false);
    },
  },
  computed: {
    docFolidOperate: {
      get() {
        return this.docFolidOperateShow;
      },
      set(value) {
        this.$emit("update:docFolidOperateShow", value);
      },
    },
  },
};
</script>

<style scoped lang="less">
/deep/.van-dialog__header {
  padding-top: 11px;
  padding-bottom: 21px;
  color: #4d340c;
  font-size: 16px;
}
.van-dialog {
  border-radius: 6px;
}

.van-field {
  background-color: #fffaf1;
}

.doc-folid-box {
  flex-direction: column;
  justify-content: center;
  background-color: #f5f5f5;
  .doc-folid-item {
    height: 50px;
    text-align: center;
    line-height: 50px;
    margin: 0;
    background-color: #fff;
    border-bottom: 1px solid #f5f5f5;
  }
}

.remove-doc-title {
  font-size: 16px;
  color: #4d340c;
  text-align: center;
  font-weight: bold;
}

.remove-doc-btn-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-around;
  bottom: 30px;
  button {
    width: 132px;
    height: 44px;
  }
  .cancel-remove-doc {
    border: 1px solid #9c7b59;
    color: #9c7b59;
  }
  .sure-remove-doc {
    background-color: #9c7b59;
    color: #fff;
  }
}
</style>
